import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import httpClient from 'services/httpClient';
import IPutEditManufacturerRequest from 'services/httpClient/request/manufacturer/IPutEditManufacturerRequest';
import IHttpClientSuccess from 'services/httpClient/responses/default/IHttpClientSuccess';

import { manufacturerActions } from '../index';
import { IEditManufacturerRequestAction } from '../reducers/edit/request';

function* edit(action: PayloadAction<IEditManufacturerRequestAction>) {
  try {
    const body: IPutEditManufacturerRequest = {
      name: action.payload.data.name.trim(),
      logo: action.payload.data.logo || null,
    };
    const response: AxiosResponse<IHttpClientSuccess> = yield call(
      httpClient.put,
      `admins/manufacturers/${action.payload.data.id}`,
      body,
    );

    yield put(
      manufacturerActions.editSuccess({
        id: action.payload.data.id,
        logo: action.payload.data.logo || null,
        name: action.payload.data.name,
      }),
    );

    action.payload.functions.closeForm();
    action.payload.functions.success(response.data.message);
  } catch (err) {
    action.payload.functions.error(err);
    yield put(manufacturerActions.editFailure());
  }
}

export default edit;
